<template>
  <div>
    <q-fab v-model="fab1" v-if="embedded || $q.screen.name==='xs' || $q.screen.name==='sm'" class="btnFabCO"
           color="white" text-color="black" icon="keyboard_arrow_left" direction="left" padding="xs">

      <div :class="styleClass" style="margin-right:0">
        <q-expansion-item expand-separator label="Legende" ref="legendRef" :default-opened="!mobile" group="group"
                          v-if="legendEnabled" header-class="expansionCard">
          <q-card>
            <q-card-section class="paddingCard">
              <legend-menu :legendEntries="legendEntries"/>
            </q-card-section>
          </q-card>
        </q-expansion-item>
        <q-expansion-item expand-separator :label="kmlTitle ? kmlTitle : 'KML'" group="group" v-if="kmlEnabled" header-class="expansionCard">
          <q-card>
            <q-card-section class="noPaddingCard">
              <kml-side-menu v-if="map != null" :map="map" :zoom="zoom" :kmlFileDir="kmlFileDir" @show-kml-error="$emit('show-kml-error', $event)" :queryResult="queryResult" :setupToken="setupToken"/>
            </q-card-section>
          </q-card>
        </q-expansion-item>
      </div>
    </q-fab>

    <div :class="styleClass" v-else>
      <q-expansion-item expand-separator label="Legende" ref="legendRef" :default-opened="!mobile" group="group"
                        v-if="legendEnabled" header-class="expansionCard">
        <q-card>
          <q-card-section class="paddingCard">
            <legend-menu :legendEntries="legendEntries"/>
          </q-card-section>
        </q-card>
      </q-expansion-item>

      <q-expansion-item expand-separator :label="kmlTitle ? kmlTitle : 'KML'" group="group" v-if="kmlEnabled" header-class="expansionCard">
        <q-card>
          <q-card-section class="noPaddingCard">
            <kml-side-menu v-if="map != null" :map="map" :zoom="zoom" :kmlFileDir="kmlFileDir" @show-kml-error="$emit('show-kml-error', $event)" :queryResult="queryResult" :setupToken="setupToken"/>
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </div>
  </div>
</template>

<script>
import kmlSideMenu from './KMLSideMenu'
import legendMenu from './LegendMenu'

export default {
  name: 'controlOverlay',
  props: {
    legendEnabled: Boolean,
    legendEntries: Array,
    kmlEnabled: Boolean,
    map: Object,
    zoom: Boolean,
    kmlFileDir: String,
    kmlTitle: String,
    embedded: Boolean,
    queryResult: Array,
    setupToken: Array
  },
  components: {legendMenu, kmlSideMenu},

  data() {
    return {
      mobile: false,
      fab1: false
    }
  },

  computed: {
    styleClass() {
      return {
        'controlOverlay': !this.mobile,
        'controlOverlayMobile': this.mobile
      }
    }
  },

  async mounted() {
    if (this.$q.screen.name == 'xs') {
      this.mobile = true
    }
  }
}
</script>

<style lang="sass">
.controlOverlay
  position: absolute
  background-color: white
  border-radius: 1px
  width: 200px
  top: 0
  right: 0
  margin: 10px
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  z-index: 2


.controlOverlayMobile
  position: absolute
  background-color: white
  border-radius: 1px
  width: 200px
  top: 0
  right: 0
  margin: 10px
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  z-index: 2


.noPaddingCard
  padding: 0
  max-height: 30vh
  overflow: auto


.paddingCard
  padding: 0 0 10px 10px
  max-height: 30vh
  overflow: auto


.expansionCard
  height: 40px
  min-height: 40px
  padding: 0 5px 0 10px


.btnFabCO
  position: absolute
  right: 10px
  top:10px

</style>
